import { useState, useEffect } from "react";
import axiosConfig from '../axiosConfig';
import Header from "../Header/Header";
import MainMenu from "../MainMenu/MainMenu";
import * as XLSX from 'xlsx';

const DataCleanse = () => {
    const [cleans, setCleans] = useState([]);
    const [lastUpdatedDate, setLastUpdatedDate] = useState("");
    const [loading, setLoading] = useState(false);
    const [Cleanable, setCleanable] = useState("");
    const [viewLog, setViewLog] = useState({});
    const [excelFile, setExcelFile] = useState(null);
    const [excelFileError, setExcelFileError] = useState(null);
    const [excelFileSuccess, setExcelFileSuccess] = useState(null);
    const [fileSubmitted, setFileSubmitted] = useState(false);
    const [proceedSuccess, setProceedSuccess] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [captcha, setCaptcha] = useState({ question: "", answer: null });
    const [userCaptchaInput, setUserCaptchaInput] = useState("");
    const [captchaError, setCaptchaError] = useState("");
    const [confirmStep, setConfirmStep] = useState(false);

    useEffect(() => {
        axiosConfig.get("/lastCleanedDate").then((rsp) => {
            const nextDate = getNextDay(rsp.data.lastCleanedDate);
            setCleans([{ date: nextDate }]);
            setCleanable(nextDate);
            setLastUpdatedDate(rsp.data.lastCleanedDate);
        });
    }, []);

    const getNextDay = (dateString) => {
        const date = new Date(dateString);
        date.setDate(date.getDate() + 1);
        return date.toISOString().split("T")[0];
    };

    const isDateLessThanToday = (dateString) => {
        const inputDate = new Date(dateString);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return inputDate < today;
    };

    const CleaNByDate = () => {
        setLoading(true);
        axiosConfig.get("/dataclense_byDate/" + Cleanable).then(
            () => {
                alert("Data Cleaned Successfully");
                setProceedSuccess(true); 
                setLoading(false);
            },
            () => setLoading(false)
        );
    };

    const FinalProceed = () => {
        setLoading(true);
        axiosConfig.get("/dataclense_final_byDate/" + Cleanable).then(
            () => {
                alert("Final Data Cleansing Completed");
                setLoading(false);
                window.location.reload();
            },
            () => setLoading(false)
        );
    };

    const Search = (e) => {
        axiosConfig.get("/v2/viewlog/" + e.target.value).then(
            (rsp) => setViewLog(rsp.data)
        );
    };

    const CleaData = (id) => {
        axiosConfig.get("/v2/clean/data/" + id).then((rsp) => {
            if (rsp.data === "Already Cleaned") alert("Already Cleaned");
            else setViewLog({});
        });
    };

    const fileTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (file && fileTypes.includes(file.type)) {
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = (e) => {
                setExcelFile(e.target.result);
                setExcelFileError(null);
                setExcelFileSuccess(null);
                setFileSubmitted(false);
            };
        } else {
            setExcelFileError("Please select a valid Excel file");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!excelFile) {
            setExcelFileError("Please select your file");
            return;
        }

        const workbook = XLSX.read(excelFile, { type: 'buffer' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(sheet);
        const ids = data
            .map(row => row[Object.keys(row)[0]])
            .filter(id => id !== undefined && id !== null && id !== "");

        if (!ids.length) {
            setExcelFileError("No valid IDs found in the uploaded file");
            return;
        }

        setLoading(true);
        setExcelFileError(null);
        setExcelFileSuccess(null);

        try {
            const rsp = await axiosConfig.post("/v2/clean/data/bulk", { ids });
            const cleanedCount = rsp?.data?.cleaned_count ?? 0;
            setExcelFileSuccess(`Viewlog Updated Successfully. Cleaned: ${cleanedCount}`);
            setFileSubmitted(true);
        } catch (error) {
            const message = error?.response?.data?.message || "Failed to clean data in bulk";
            setExcelFileError(message);
            setFileSubmitted(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header title="Data Cleansing" />
            <MainMenu menu="datacleansing" />

            <div className="app-content content">
                <div className="content-wrapper" style={{ backgroundColor: "azure" }}>
                    <div className="content-body">

                        <div className="row mb-2">
                            <div className="col-md-5 text-center">
                                <h3>Cleansing Status</h3>
                                <h6>Last Cleaned at {lastUpdatedDate}</h6>
                            </div>
                            <div className="col-md-4 offset-md-3">
                                <input
                                    className="form-control"
                                    placeholder="Search with ViewLog Id"
                                    onChange={Search}
                                />
                            </div>
                        </div>

                        {cleans.map(c => (
                            <div className="row" key={c.date}>
                                <div className="col-md-5">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{c.date}</td>
                                                <td>Raw</td>
                                                <td>
                                                    {!loading && !proceedSuccess && (
                                                        <button
                                                            className="btn btn-danger"
                                                            disabled={!isDateLessThanToday(Cleanable)}
                                                            onClick={() => {
                                                                const a = Math.floor(Math.random() * 10);
                                                                const b = Math.floor(Math.random() * 10);
                                                                setCaptcha({ question: `${a} + ${b}`, answer: a + b });
                                                                setConfirmStep(false);
                                                                setShowModal(true);
                                                            }}
                                                        >
                                                            Proceed
                                                        </button>
                                                    )}

                                                    {!loading && proceedSuccess && (
                                                        <button
                                                            className="btn btn-warning"
                                                            onClick={FinalProceed}
                                                        >
                                                            Final Proceed
                                                        </button>
                                                    )}

                                                    {loading && <span>Processing...</span>}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-md-7">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Log Id</th>
                                                <th>Channel</th>
                                                <th>User</th>
                                                <th>Started</th>
                                                <th>Finished</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{viewLog.id}</td>
                                                <td>{viewLog.channel_id}</td>
                                                <td>{viewLog.user_id}</td>
                                                <td>{viewLog.started_watching_at}</td>
                                                <td>{viewLog.finished_watching_at}</td>
                                                <td>
                                                    <button
                                                        className="btn btn-danger"
                                                        onClick={() => CleaData(viewLog.id)}
                                                    >
                                                        Clean
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <form onSubmit={handleSubmit}>
                                        <h5>Upload Excel file</h5>
                                        <input type="file" className="form-control" onChange={handleFile} />
                                        {excelFileError && <div className="text-danger">{excelFileError}</div>}
                                        {excelFileSuccess && <div className="text-success">{excelFileSuccess}</div>}
                                        <button className="btn btn-success mt-2">Submit</button>
                                    </form>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* MODAL */}
            {showModal && (
                <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5>{confirmStep ? "Confirm" : "Captcha"}</h5>
                                <button className="close" onClick={() => setShowModal(false)}>×</button>
                            </div>
                            <div className="modal-body">
                                {!confirmStep ? (
                                    <>
                                        <p>Solve: <strong>{captcha.question}</strong></p>
                                        <input
                                            className="form-control"
                                            onChange={(e) => setUserCaptchaInput(e.target.value)}
                                        />
                                        {captchaError && <p className="text-danger">{captchaError}</p>}
                                    </>
                                ) : (
                                    <p>Are you sure you want to proceed?</p>
                                )}
                            </div>
                            <div className="modal-footer">
                                {!confirmStep ? (
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                            if (parseInt(userCaptchaInput) === captcha.answer) {
                                                setConfirmStep(true);
                                            } else {
                                                setCaptchaError("Incorrect captcha");
                                            }
                                        }}
                                    >
                                        Submit
                                    </button>
                                ) : (
                                    <>
                                        <button
                                            className="btn btn-success"
                                            onClick={() => {
                                                if (!fileSubmitted) {
                                                    alert("Please submit the file first!");
                                                } else {
                                                    setShowModal(false);
                                                    CleaNByDate();
                                                }
                                            }}
                                        >
                                            YES
                                        </button>
                                        <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                            Cancel
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DataCleanse;